<template>
  <div class="select-item-placeholder">
    <div class="select-item-placeholder__small"></div>
    <div class="select-item-placeholder__full">
      <div class="select-item-placeholder__content-bar"></div>
    </div>
    <div class="select-item-placeholder__small"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

/**
 *
 * Placeholder for SelectItem and similar components, to show when
 * the actual component hasn't rendered yet
 */
export default defineComponent({
  name: 'SelectItemPlaceholder',
});
</script>

<style lang="scss">
@use 'settings/colors';
.select-item-placeholder {
  width: 100%;
  height: 32px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 8px;
  padding: 0 4px 0 8px;
}

.select-item-placeholder__small {
  width: 24px;
}

.select-item-placeholder__full {
  width: 100%;
}

.select-item-placeholder__content-bar {
  height: 8px;
  background: colors.$color-grey-100;
  border-radius: 4px;
}
</style>
